const data = [
  {
    title: "pianoforte СОНАТА О СКАЗКЕ",
    url: "https://youtu.be/fegvuurxnFI",
    year: "1961",
  },
  {
    title: "ПРАЩА оркестрохора",
    url: "",
    year: "1962",
  },
  {
    title: "DIADA пентáэдр",
    url: "",
    year: "1962",
  },
  {
    title: "ЗАСЕДАНИЕ смычковых у тромбона",
    url: "",
    year: "1963",
  },
  {
    title: "BURLESCA",
    url: "",
    year: "1963",
  },
  {
    title: "NON STOP песен пионеров",
    url: "",
    year: "1963",
  },
  {
    title: "PLAY",
    url: "",
    year: "1963",
  },
  {
    title: "ТОСТ РОБЕРТА БЁРНСА",
    url: "",
    year: "1963",
  },
  {
    title: "КРАССИЧЕСКОЕ",
    url: "",
    year: "1963",
  },
  {
    title: "ΧΡÓΝOΣ",
    url: "",
    year: "1963",
  },
  {
    title: "OSTINATI del violincello",
    url: "",
    year: "1964",
  },
  {
    title: "КАПЕЛЛА АНГЕЛА",
    url: "",
    year: "1964",
  },
  {
    title: "MUSIQUE MILITAIRE",
    url: "",
    year: "1964",
  },
  {
    title: "PLEIN AIR / INTERIEUR",
    url: "",
    year: "1964",
  },
  {
    title: "ФУГА ГЛУПОСТИ",
    url: "",
    year: "1964",
  },
  {
    title: "TURNO A TURNO",
    url: "",
    year: "1964",
  },
  {
    title: "IN VIA с бесструнными",
    url: "",
    year: "1964",
  },
  {
    title: "МАРШАК – ЭПИГРАММЫ",
    url: "",
    year: "1964",
  },
  {
    title: "ФОНОГРАФИЯ 65",
    url: "",
    year: "1965",
  },
  {
    title: "ORCHESTRA GROSSA взыскующих",
    url: "",
    year: "1965",
  },
  {
    title: "PASSACAGLIA",
    url: "",
    year: "1966",
  },
  {
    title: "150 000 000 дифирамб",
    url: "",
    year: "1966",
  },
  {
    title: "БЕЛЕНЬКАЯ И ЧЕРНЕНЬКАЯ",
    url: "",
    year: "1968",
  },
  {
    title: "ARGUMENTA DE JURE 16-ти хоров",
    url: "https://youtu.be/hE2uF9Be9QA",
    year: "1969",
  },
  {
    title: "ПЕСЕНКИ ВО СНЕ",
    url: "",
    year: "1972",
  },
  {
    title: "A PRIMA VISTA",
    url: "https://youtu.be/Ksn4iKp21GI?si=QXz_f7jL7m5dEGN7",
    year: "1972",
  },
  {
    title: "APPELLI татьяны ворониной",
    url: "",
    year: "1972",
  },
  {
    title: "STATUS NASTENDI",
    url: "https://youtu.be/NxW0YHkohIo?si=xNuvdhCt2ebSXXp3",
    year: "1975",
  },
  {
    title: "ДВАЖДЫ ДВА",
    url: "",
    year: "1975",
  },
  {
    title: "ВАМПАМПЕТ",
    url: "",
    year: "1975",
  },
  {
    title: "ЖАННА (PASSION) (1970-1978)",
    url: "https://youtu.be/SnY2YLhJ6bs",
    year: "1978",
  },
  {
    title: "АЙНАНА вариации",
    url: "",
    year: "1978",
  },
  {
    title: "ТРИ КРЫЛА",
    url: "https://music.yandex.ru/album/35413752/track/136149391",
    year: "1979",
  },
  {
    title: "JAMES JOYCE JAZZ",
    url: "",
    year: "1980",
  },
  {
    title: "АРТ",
    url: "",
    year: "1980",
  },
  {
    title: "СТРОФА ПОСВЯЩЕНИЯ",
    url: "https://music.yandex.ru/album/35413752/track/136149396",
    year: "1980",
  },
  {
    title: "КЛИК",
    url: "",
    year: "1980",
  },
  {
    title: "SOLARIS в 35 гонгов",
    url: "https://www.youtube.com/watch?v=2Bxbs9sX3ug&list=PLcnxwMUzj9W9PdFQq-E8gIQx_K4Jwyj7n",
    year: "1980",
  },
  {
    title: "ДА гимн солистов",
    url: "",
    year: "1980",
  },
  {
    title: "ГЛУПАЯ ЛОШАДЬ четы",
    url: "https://youtu.be/7uBBZ0sKPN8",
    year: "1981",
  },
  {
    title: "LIVE",
    url: "",
    year: "1981",
  },
  {
    title: "СЛУЧАЙНОЕ дитя пространств",
    url: "",
    year: "1982",
  },
  {
    title: "ПРА РОК",
    url: "https://music.yandex.ru/album/35413752/track/136149399",
    year: "1982",
  },
  {
    title: "НАУКА УМЕЕТ МНОГО ГИТИК (1973-1984)",
    url: "",
    year: "1984",
  },
  {
    title: "subbassi НИКА",
    url: "https://youtu.be/6OQAI7Qjzeg",
    year: "1984",
  },
  {
    title: "QUAL È’L GEOMÈTRA CHE TUTTO",
    url: "",
    year: "1984",
  },
  {
    title: "ЭПИТАФИИ",
    url: "",
    year: "1984",
  },
  {
    title: "ЧУРИКИ",
    url: "https://music.yandex.ru/album/35413752/track/136149405",
    year: "1984",
  },
  {
    title: "ода гавриила державина и детей друзей БОГ",
    url: "",
    year: "1985",
  },
  {
    title: "AGNUS DEI",
    url: "https://youtu.be/_NqERSciTP4",
    year: "1985",
  },
  {
    title: "фреска НАД БЕЗДНОЙ",
    url: "",
    year: "1986",
  },
  {
    title: "POSTPOSTSCRIPTUM",
    url: "",
    year: "1987",
  },
  {
    title: "СКВОЗЬ РАДУГУ НЕВОЛЬНЫХ СЛЕЗ трио певицы и виолончелиста",
    url: "",
    year: "1988",
  },
  {
    title: "LITANIA оркестру солистов",
    url: "https://music.yandex.ru/album/35413752/track/136149410",
    year: "1988",
  },
  {
    title: "CHRISTE, ELEISON",
    url: "",
    year: "1988",
  },
  {
    title: "NOTTURNO",
    url: "https://music.yandex.ru/album/35413752/track/136149412",
    year: "1988",
  },
  {
    title: "ШРАМ-МАРШ у радиолы",
    url: "",
    year: "1988",
  },
  {
    title: "КОЛЫБЕЛЬНЫЕ ОКОН",
    url: "",
    year: "1988",
  },
  {
    title: "ВОЗНОШЕНИЕ хора смычковых",
    url: "",
    year: "1991",
  },
  {
    title: "МОЛИТВА СВЯТОГО ЕФРЕМА СИРИНА",
    url: "https://youtu.be/_4gJUfo_QKg",
    year: "1991",
  },
  {
    title: "СВЕТЕ ТИХИЙ песнь пресвятой богородицы",
    url: "https://youtu.be/ASDAqWyoulw",
    year: "1991",
  },
  {
    title: "bАХ второй гимн солистов",
    url: "",
    year: "1992",
  },
  {
    title: "ИОНУС",
    url: "",
    year: "1992",
  },
  {
    title: "GLOSSOLALIA лестницы Иакова",
    url: "",
    year: "1992",
  },
  {
    title: "CANTUS тишины до темноты",
    url: "",
    year: "1993",
  },
  {
    title: "ВОСЬМАЯ ГЛАВА canticum canticorum",
    url: "https://youtu.be/AH2JqTlhBJ8",
    year: "1993",
  },
  {
    title: "MARAN ATHA (версиям)",
    url: "",
    year: "1993",
  },
  {
    title: "БАБОЧКА БРОДСКОГО",
    url: "",
    year: "1993",
  },
  {
    title: "ARIA",
    url: "",
    year: "1993",
  },
  {
    title: "В ЭФИРЕ ЧИСТОМ И НЕЗРИМОМ",
    url: "",
    year: "1994",
  },
  {
    title: "ОСЕННИЙ ВЕЧЕР",
    url: "",
    year: "1994",
  },
  {
    title: "ПЯТИДЕСЯТЫЙ ПСАЛОМ",
    url: "",
    year: "1995",
  },
  {
    title: "ОБЛАЧЕННАЯ В СОЛНЦЕ солистке солистов",
    url: "https://www.youtube.com/watch?v=dP6JzFFcuNo&t=1s",
    year: "1995",
  },
  {
    title: "БЛАЖЕНСТВА",
    url: "https://www.youtube.com/watch?v=HrNgv2EfR1E ",
    year: "1996",
  },
  {
    title: "БЛАЖЕНСТВО стихотворения александра пушкина",
    url: "",
    year: "1997",
  },
  { title: "LUX AETERNA псалмопевцев", url: "", year: "1997" },
  { title: "СИЕ ДИТЯ", url: "", year: "1997" },
  {
    title: "времена года сергея вакуленко БЕЛЫМ ПО БЕЛОМУ",
    url: "",
    year: "1998",
  },
  { title: "СКИНИЯ", url: "", year: "1998" },
  { title: "СНЕЖИНКА НА ПАУТИНКЕ", url: "", year: "1998" },
  { title: "ВЕТОЧКИ ДНЯ", url: "", year: "1999" },
  { title: "СИНИЕ ПЁРЫШКИ", url: "", year: "2001" },
  { title: "УТРЕННИЕ МОЛИТВЫ", url: "", year: "2001" },
  { title: "ENTRÉE с контрабасом", url: "", year: "2001" },
  { title: "мгновенье рыбака и рыбки", url: "", year: "2002" },
  {
    title: "ЛУКОМОРЬЕ",
    url: "https://www.youtube.com/watch?v=NrJWgkmZOck ",
    year: "2002",
  },
  { title: "ХЕРУВИМСКАЯ ПЕСНЬ", url: "", year: "2004" },
  { title: "баечка ВОТ!", url: "", year: "2004" },
  { title: "ЧАША в псалмах хора хоров", url: "", year: "2004" },
  {
    title: "ДАГЕРРОТИП",
    url: "https://music.yandex.ru/album/35413752/track/136149400",
    year: "2004",
  },
  {
    title: "балаган О ПОПЕ И РАБОТНИКЕ ЕГО БАЛДЕ",
    url: "https://youtu.be/c2CyZCAyoEU",
    year: "2004",
  },
  { title: "БУСИНКИ НЮЫ", url: "", year: "2004" },
  { title: "МОЛИТВА СВЯТОМУ ДУХУ (1994-2005)", url: "", year: "2005" },
  { title: "SETTIMINO", url: "", year: "2006" },
  { title: "ВЛАДЫКО ДНЕЙ МОИХ", url: "", year: "2006" },
  { title: "ветерочек", url: "", year: "2007" },
  { title: "танцы восхождения БРИДЖ", url: "", year: "2008" },
  { title: "Е.Ф.", url: "", year: "2008" },
  { title: "ЧАЕПИТИЕ СО СДВИГОМ royal version", url: "", year: "2009" },
  { title: "ЦАРЕВНА прелюдия хоров и солистов", url: "", year: "2010" },
  {
    title: "репортаж СПИЦА БУЯНА",
    url: "https://youtu.be/rRKZd8UwXTg",
    year: "2010",
  },
  { title: "АЛЛИЛУИЯ", url: "", year: "2015" },
  { title: "БЫТЬ гимн третий", url: "", year: "2017" },
  { title: "DEIN", url: "", year: "2018" },
  { title: "FEST", url: "", year: "2018" },
  { title: "ἀββᾶ", url: "", year: "2018" },
  { title: "АЙДА!", url: "", year: "2019" },
  { title: "ЛЕЛЬ", url: "", year: "2019" },
  { title: "ТИ", url: "", year: "2019" },
  { title: "тебе", url: "", year: "2019" },
  { title: "УЖ И ЁЖ", url: "", year: "2020" },
  { title: "КРАСА И ДИВО", url: "", year: "2020" },
  { title: "О БОЖЕ", url: "", year: "2021" },
  { title: "СОЧЕЛЬНИК", url: "", year: "2022" },
  { title: "БЕЗДЕЛИЦА", url: "", year: "2022" },
  { title: "НЕ ПЕРЕСКОРОГОВОРИШЬ", url: "", year: "2022" },
];

export default data;
